import * as R from 'ramda';

export const setSuggestionGroupsMutation = (state, data) => {
    state.suggestionGroups = data;
};
export const addSuggestionGroupMutation = (state, data) => {
    state.suggestionGroups.push(data);
};
export const editSuggestionGroupMutation = (state, data) => {
    const item = state.suggestionGroups.find(item => item.id === data.id);
    Object.assign(item, data);
};
export const deleteSuggestionGroupMutation = (state, data) => {
    const index = R.findIndex(R.propEq('id', data['id']))(state.suggestionGroups);
    state.suggestionGroups.splice(index, 1);
};
